module.exports = __webpack_public_path__ + "img/image-04.445f0f79.jpeg";